/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConfidenceStatsConfidenceCategoriesInner } from './ConfidenceStatsConfidenceCategoriesInner';
import {
    ConfidenceStatsConfidenceCategoriesInnerFromJSON,
    ConfidenceStatsConfidenceCategoriesInnerFromJSONTyped,
    ConfidenceStatsConfidenceCategoriesInnerToJSON,
} from './ConfidenceStatsConfidenceCategoriesInner';

/**
 * 
 * @export
 * @interface ConfidenceStats
 */
export interface ConfidenceStats {
    /**
     * 
     * @type {Array<ConfidenceStatsConfidenceCategoriesInner>}
     * @memberof ConfidenceStats
     */
    confidenceCategories: Array<ConfidenceStatsConfidenceCategoriesInner>;
    /**
     * 
     * @type {number}
     * @memberof ConfidenceStats
     */
    total: number;
}

/**
 * Check if a given object implements the ConfidenceStats interface.
 */
export function instanceOfConfidenceStats(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "confidenceCategories" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function ConfidenceStatsFromJSON(json: any): ConfidenceStats {
    return ConfidenceStatsFromJSONTyped(json, false);
}

export function ConfidenceStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfidenceStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'confidenceCategories': ((json['confidence_categories'] as Array<any>).map(ConfidenceStatsConfidenceCategoriesInnerFromJSON)),
        'total': json['total'],
    };
}

export function ConfidenceStatsToJSON(value?: ConfidenceStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'confidence_categories': ((value.confidenceCategories as Array<any>).map(ConfidenceStatsConfidenceCategoriesInnerToJSON)),
        'total': value.total,
    };
}

